import React from 'react';
import { Link } from 'react-router-dom';
import { cx, css } from '@emotion/css';

// Import custom premium background assets
import batchesheroImg from '../../assets/gen_images/batcheshero.png';
import batchesiconImg from '../../assets/gen_images/batchesicon.png';

const cardStyles = css`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 380px;
  border-radius: 28px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0px 10px 30px rgba(241, 102, 2, 0.05);
  border: 1.5px solid rgba(241, 102, 2, 0.18);
  background: linear-gradient(to bottom, #fffcf9 0%, #fff3e6 65%, #ffe6cc 100%);
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 25px 50px rgba(241, 102, 2, 0.15), 0 0 35px rgba(241, 102, 2, 0.08);
    text-decoration: none;
    border-color: rgba(241, 102, 2, 0.45);
    background: linear-gradient(to bottom, #fffcf9 0%, #fff0e0 55%, #ffd4a8 100%);

    .card-logo-container {
      border-color: #f16602;
      box-shadow: 0 15px 40px rgba(241, 102, 2, 0.2);
      transform: scale(1.05);
      
      img, svg.main-icon {
        transform: scale(1.1);
      }
    }

    .logo-glow {
      transform: scale(1.2);
      opacity: 0.8;
    }
  }

  .card-logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.2rem;
    margin-bottom: 0.8rem;
    position: relative;
  }

  .card-logo-container {
    width: 130px;
    height: 130px;
    border-radius: 36px;
    overflow: hidden;
    background: #ffffff;
    border: 2px solid rgba(241, 102, 2, 0.18);
    box-shadow: 0 10px 35px rgba(241, 102, 2, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 2;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 12px;
      transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    }
  }

  .logo-glow {
    position: absolute;
    width: 210px;
    height: 210px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(241, 102, 2, 0.15) 0%, transparent 70%);
    filter: blur(8px);
    z-index: 1;
    pointer-events: none;
    transition: all 0.4s ease;
  }

  .card-icon-container {
    position: absolute;
    top: 1.2rem;
    left: 1.2rem;
    z-index: 3;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(241, 102, 2, 0.18);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-badge-container {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    z-index: 3;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(241, 102, 2, 0.18);
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.68rem;
    font-weight: 700;
    color: #f16602;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    gap: 6px;

    .badge-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #f16602;
      box-shadow: 0 0 8px #f16602;
    }
  }

  .edit-btn-top {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    z-index: 10;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(241, 102, 2, 0.18);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(241, 102, 2, 0.08);
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.08);
      background: #ffffff;
      border-color: #f16602;
    }
  }

  .card-content-area {
    padding: 0 1.5rem 1.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex-grow: 1;
  }

  .card-subtitle {
    font-size: 0.68rem;
    font-weight: 700;
    color: #f16602;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    margin-bottom: 0.4rem;
  }

  .card-title {
    font-size: 1.55rem;
    font-weight: 800;
    color: #382110;
    text-transform: uppercase;
    letter-spacing: -0.01em;
    margin: 0 0 0.8rem 0;
    line-height: 1.25;
  }

  .info-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
    padding: 0;
    margin: 0 0 1.2rem 0;
    list-style: none;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.84rem;
    color: #594436;
    font-weight: 600;
  }

  .info-icon {
    font-size: 0.95rem;
    color: #f16602;
  }

  .btn-danger {
    cursor: pointer;
    padding: 0.72rem;
    width: 100%;
    background: transparent;
    border: 1.5px solid rgba(255, 77, 77, 0.5);
    color: #ff4d4d;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-radius: 9999px;
    transition: all 0.3s ease;
    text-align: center;

    &:hover {
      background: #ff4d4d;
      border-color: #ff4d4d;
      color: #ffffff;
      box-shadow: 0 6px 15px rgba(255, 77, 77, 0.25);
    }
  }

  .btn-primary {
    cursor: pointer;
    padding: 0.8rem;
    width: 100%;
    background: #f16602;
    font-size: 0.8rem;
    font-weight: 700;
    color: #ffffff;
    border: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-radius: 9999px;
    box-shadow: 0 4px 15px rgba(241, 102, 2, 0.25);
    transition: all 0.3s ease;
    text-align: center;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(241, 102, 2, 0.35);
    }
  }
`;

function BatchNewCard(props) {
  const { isCreate, name, imgsrc, students, owner, onDelete, id, category } = props;

  if (isCreate) {
    return (
      <div className={cx(cardStyles)} onClick={props.onClick} style={{ cursor: 'pointer' }}>
        {/* Top Left Floating Icon */}
        <div className="card-icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px', color: '#f16602' }}>
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </div>

        <div className="card-badge-container">
          <span className="badge-dot" />
          <span>NEW</span>
        </div>

        {/* Center Logo Container with glow */}
        <div className="card-logo-wrapper">
          <div className="card-logo-container" style={{ borderStyle: 'dashed', borderWidth: '2.5px' }}>
            <svg className="main-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#f16602" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '80px', height: '80px', transition: 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)' }}>
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </div>
          <div className="logo-glow" />
        </div>

        <div className="card-content-area">
          <div className="card-subtitle">GET STARTED</div>
          <h3 className="card-title">Create New Batch</h3>
          <p style={{ fontSize: '0.84rem', color: '#594436', lineHeight: '1.45', margin: '0 0 1.2rem 0', fontWeight: '500' }}>
            Add a new group of students to manage their learning journey.
          </p>
          <button className="btn-primary">Create Batch</button>
        </div>
      </div>
    );
  }

  return (
    <div className={cx(cardStyles)}>
      {/* Top Left Floating Icon */}
      <div className="card-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px', color: '#f16602' }}>
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>

      {/* Top Right Floating Edit Button */}
      <Link to={{ pathname: "/editbatch", state: { id, owner, name, students, category } }} className="edit-btn-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '18px', height: '18px', color: '#f16602' }}>
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      </Link>

      {/* Center Logo Container with glow */}
      <div className="card-logo-wrapper">
        <div className="card-logo-container">
          <img src={imgsrc} alt={name} />
        </div>
        <div className="logo-glow" />
      </div>

      <div className="card-content-area">
        <div className="card-subtitle">Student Batch</div>
        <h3 className="card-title">{name}</h3>

        <ul className="info-list">
          <li className="info-item">
            <span className="info-icon">👥</span>
            <span>{students ? students.length : 0} Students</span>
          </li>
          <li className="info-item">
            <span className="info-icon">👑</span>
            <span>Owner: {owner || 'Admin'}</span>
          </li>
          <li className="info-item">
            <span className="info-icon">🏷️</span>
            <span>Category: {category}</span>
          </li>
        </ul>

        <button className="btn-danger" onClick={onDelete}>Delete Batch</button>
      </div>
    </div>
  );
}

export default BatchNewCard;
